export const REGION_CENTERS = {
  "Abruzzo": [42.35, 13.8], "Basilicata": [40.5, 16.08], "Calabria": [39.05, 16.5],
  "Campania": [40.85, 14.6], "Emilia-Romagna": [44.5, 11.0], "Friuli-Venezia Giulia": [46.1, 13.1],
  "Lazio": [41.9, 12.75], "Liguria": [44.3, 8.7], "Lombardia": [45.6, 9.8], "Marche": [43.35, 13.1],
  "Molise": [41.65, 14.6], "Piemonte": [45.05, 7.9], "Puglia": [41.0, 16.6], "Sardegna": [40.1, 9.0],
  "Sicilia": [37.5, 14.1], "Toscana": [43.45, 11.1], "Trentino-Alto Adige": [46.45, 11.3],
  "Umbria": [42.95, 12.5], "Valle d'Aosta": [45.75, 7.4], "Veneto": [45.6, 11.9],
};

export const REGIONS = ["Tutta Italia", ...Object.keys(REGION_CENTERS)];

export function nearestRegion(lat, lng) {
  let best = null, bestD = Infinity;
  Object.entries(REGION_CENTERS).forEach(([name, [la, ln]]) => {
    const d = (la - lat) ** 2 + ((ln - lng) * Math.cos((lat * Math.PI) / 180)) ** 2;
    if (d < bestD) { bestD = d; best = name; }
  });
  return best;
}
